

const Footer = () => {
  return <div className="footer mt-2 rounded-t-4xl bg-gray-100 shadow flex p-2 borde h-18 w-full items-center justify-center">Footer</div>;
};

export default Footer;
